/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface ProjectTaxesTaxPrmsEnumsRetrieve$Params {
  project_id: string;
}

export function projectTaxesTaxPrmsEnumsRetrieve(
  http: HttpClient,
  rootUrl: string,
  params: ProjectTaxesTaxPrmsEnumsRetrieve$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, projectTaxesTaxPrmsEnumsRetrieve.PATH, 'get');
  if (params) {
    rb.path('project_id', params.project_id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

projectTaxesTaxPrmsEnumsRetrieve.PATH = '/api/project_taxes/tax_prms/enums/{project_id}';
